(function () {
  function ready(callback) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", callback);
    } else {
      callback();
    }
  }

  ready(function () {
    var config = window.JalisiSmartParentAdvisorConfig;
    if (!config || !config.questions || !config.questions.length) return;

    var roots = document.querySelectorAll("[data-jalisi-advisor-root]");
    if (!roots.length) return;

    Array.prototype.forEach.call(roots, function (root, index) {
      if (root.getAttribute("data-jalisi-advisor-initialized") === "true") return;
      root.setAttribute("data-jalisi-advisor-initialized", "true");
      initAdvisor(root, config, index);
    });
  });

  function initAdvisor(root, config, index) {
    var state = {
      step: 0,
      answers: {}
    };

    function track(eventName, payload) {
      if (!eventName) return;
      var advisorPayload = payload || {};

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: eventName, advisor: advisorPayload });

      if (typeof window.gtag === "function") {
        try {
          window.gtag("event", eventName, advisorPayload);
        } catch (error) {}
      }

      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === "function") {
        try {
          window.Shopify.analytics.publish(eventName, advisorPayload);
        } catch (error) {}
      }
    }

    function escapeText(value) {
      return String(value || "").replace(/[&<>"']/g, function (character) {
        return {
          "&": "&amp;",
          "<": "&lt;",
          ">": "&gt;",
          '"': "&quot;",
          "'": "&#39;"
        }[character];
      });
    }

    function questionById(id) {
      return config.questions.filter(function (item) { return item.id === id; })[0];
    }

    function answerOption(id) {
      var question = questionById(id);
      var value = state.answers[id];
      if (!question || !value) return null;
      return question.options.filter(function (item) { return item.value === value; })[0] || null;
    }

    function answerLabel(id) {
      var option = answerOption(id);
      return option ? option.label : "";
    }

    function answerValue(id) {
      var option = answerOption(id);
      return option ? option.value : "";
    }

    function messageTokenValue(token) {
      return {
        age: answerLabel("age"),
        arabicLevel: answerLabel("arabicLevel"),
        concern: answerLabel("concern"),
        readingTime: answerLabel("readingTime"),
        country: answerLabel("country")
      }[token] || "";
    }

    function interpolateMessage(template) {
      return String(template || "").replace(/\{([a-zA-Z0-9_]+)\}/g, function (match, token) {
        return messageTokenValue(token);
      });
    }

    function whatsappUrl() {
      var phone = String(config.whatsappPhone || "").replace(/[^0-9]/g, "");
      var message = config.result.whatsappMessage || "";
      var answeredMessage = config.result.whatsappAnsweredMessage;

      if (state.answers && Object.keys(state.answers).length && answeredMessage) {
        if (Array.isArray(answeredMessage)) {
          message = answeredMessage.map(interpolateMessage).join("\n");
        } else {
          message = interpolateMessage(answeredMessage);
        }
      }

      return "https://wa.me/" + phone + "?text=" + encodeURIComponent(message);
    }

    function orderUrl() {
      return root.getAttribute("data-order-url") || "#jalisi-order";
    }

    function resetQuiz() {
      state.step = 0;
      state.answers = {};
    }

    function openModal() {
      resetQuiz();
      modal.classList.add("is-open");
      modal.setAttribute("aria-hidden", "false");
      document.documentElement.style.overflow = "hidden";
      renderQuestion();
      track(config.trackingEvents.opened, { advisorIndex: index });
    }

    function closeModal() {
      modal.classList.remove("is-open");
      modal.setAttribute("aria-hidden", "true");
      document.documentElement.style.overflow = "";
      if (openButton && typeof openButton.focus === "function") openButton.focus();
    }

    function renderQuestion() {
      var question = config.questions[state.step];
      if (!question) return;

      var progress = Math.round(((state.step + 1) / config.questions.length) * 100);
      panelBody.innerHTML = [
        '<div class="jalisi-advisor-progress">',
        '<span>' + escapeText(config.controls.progress) + " " + (state.step + 1) + " / " + config.questions.length + '</span>',
        '<div class="jalisi-advisor-bar" aria-hidden="true"><span style="width:' + progress + '%"></span></div>',
        "</div>",
        '<div class="jalisi-advisor-question">',
        "<h3>" + escapeText(question.text) + "</h3>",
        '<div class="jalisi-advisor-options">',
        question.options.map(function (option) {
          return '<button class="jalisi-advisor-option" type="button" data-value="' + escapeText(option.value) + '" data-flag="' + escapeText(option.flag || "") + '">' + escapeText(option.label) + "</button>";
        }).join(""),
        "</div>",
        state.step > 0 ? '<button class="jalisi-advisor-back" type="button">' + escapeText(config.controls.back) + "</button>" : "",
        "</div>"
      ].join("");

      var firstOption = panelBody.querySelector(".jalisi-advisor-option");
      if (firstOption && typeof firstOption.focus === "function") firstOption.focus();
    }

    function selectedFlags() {
      var flags = {};
      config.questions.forEach(function (question) {
        var value = state.answers[question.id];
        var option = question.options.filter(function (item) { return item.value === value; })[0];
        if (option && option.flag) flags[option.flag] = true;
      });
      return flags;
    }

    function trackingPayload() {
      return {
        age: answerLabel("age"),
        ageValue: answerValue("age"),
        arabicLevel: answerLabel("arabicLevel"),
        arabicLevelValue: answerValue("arabicLevel"),
        concern: answerLabel("concern"),
        concernValue: answerValue("concern"),
        readingTime: answerLabel("readingTime"),
        readingTimeValue: answerValue("readingTime"),
        country: answerLabel("country"),
        countryValue: answerValue("country")
      };
    }

    function renderResult() {
      var additions = config.result.additions || {};
      var paragraphs = [config.result.base];
      var flags = selectedFlags();

      ["screenTime", "weakArabic", "dislikesReading", "multipleChildren"].forEach(function (flag) {
        if (flags[flag] && additions[flag]) paragraphs.push(additions[flag]);
      });

      panelBody.innerHTML = [
        '<div class="jalisi-advisor-result">',
        "<h3>" + escapeText(config.result.title) + "</h3>",
        paragraphs.map(function (paragraph) {
          return "<p>" + escapeText(paragraph) + "</p>";
        }).join(""),
        '<div class="jalisi-advisor-result-actions">',
        '<a class="jalisi-advisor-order" href="' + escapeText(orderUrl()) + '">' + escapeText(config.result.primaryCta) + "</a>",
        '<a class="jalisi-advisor-help" href="' + escapeText(whatsappUrl()) + '" target="_blank" rel="noopener">' + escapeText(config.result.whatsappCta) + "</a>",
        "</div>",
        "</div>"
      ].join("");

      track(config.trackingEvents.completed, trackingPayload());
    }

    root.classList.add("jalisi-advisor");
    root.innerHTML = [
      '<div class="jalisi-advisor-cta" dir="rtl">',
      "<div>",
      "<h2>" + escapeText(config.cta.headline) + "</h2>",
      "<p>" + escapeText(config.cta.subheadline) + "</p>",
      "</div>",
      '<button class="jalisi-advisor-open" type="button">' + escapeText(config.cta.button) + "</button>",
      "</div>"
    ].join("");

    var openButton = root.querySelector(".jalisi-advisor-open");
    var modal = document.createElement("div");
    modal.className = "jalisi-advisor-modal";
    modal.setAttribute("role", "dialog");
    modal.setAttribute("aria-modal", "true");
    modal.setAttribute("aria-hidden", "true");
    modal.setAttribute("dir", "rtl");
    modal.innerHTML = [
      '<div class="jalisi-advisor-panel" role="document">',
      '<button class="jalisi-advisor-close" type="button" aria-label="' + escapeText(config.controls.close) + '">×</button>',
      '<div class="jalisi-advisor-body"></div>',
      "</div>"
    ].join("");
    document.body.appendChild(modal);

    var panelBody = modal.querySelector(".jalisi-advisor-body");

    openButton.addEventListener("click", openModal);
    modal.querySelector(".jalisi-advisor-close").addEventListener("click", closeModal);
    modal.addEventListener("click", function (event) {
      if (event.target === modal) closeModal();
    });

    modal.addEventListener("click", function (event) {
      var option = event.target.closest(".jalisi-advisor-option");
      if (option) {
        var question = config.questions[state.step];
        state.answers[question.id] = option.getAttribute("data-value");
        state.step += 1;
        if (state.step >= config.questions.length) renderResult();
        else renderQuestion();
        return;
      }

      if (event.target.closest(".jalisi-advisor-back")) {
        state.step = Math.max(0, state.step - 1);
        renderQuestion();
        return;
      }

      if (event.target.closest(".jalisi-advisor-order")) {
        track(config.trackingEvents.orderClicked, trackingPayload());
        return;
      }

      if (event.target.closest(".jalisi-advisor-help")) {
        track(config.trackingEvents.whatsappClicked, trackingPayload());
      }
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && modal.classList.contains("is-open")) closeModal();
    });
  }
}());
